import { getMonthlyLastWeekdayRecurrenceDates } from '../forms/event/WhereAndWhen/lib/getMonthlyLastWeekdayRecurrenceDates.ts';
import { getMonthlyWeekdayRecurrenceDates } from '../forms/event/WhereAndWhen/lib/getMonthlyWeekdayRecurrenceDates.ts';
import { getRecurrenceDatesSameDay } from '../forms/event/WhereAndWhen/lib/getRecurrenceDatesSameDay.ts';

type RecurrenceRate = 'weekly' | 'bi-weekly' | 'monthly';

interface RecurrenceParams {
  date: Date;
  recurrenceRate: RecurrenceRate;
  monthRecurrenceType: string | null;
  noOfEvents: number | null;
}

export function generateRecurrences({
  date,
  noOfEvents,
  recurrenceRate,
  monthRecurrenceType,
}: RecurrenceParams): Date[] {
  if (!noOfEvents) {
    return [];
  }

  if (
    recurrenceRate === 'weekly' ||
    recurrenceRate === 'bi-weekly' ||
    (recurrenceRate === 'monthly' && monthRecurrenceType === 'day-of-month')
  ) {
    return getRecurrenceDatesSameDay({
      recurrenceRate,
      amount: noOfEvents,
      startDate: date,
    });
  }

  if (recurrenceRate === 'monthly' && monthRecurrenceType === 'nth-weekday-of-month') {
    return getMonthlyWeekdayRecurrenceDates({
      startDate: date,
      amount: noOfEvents,
    });
  }

  if (recurrenceRate === 'monthly' && monthRecurrenceType === 'last-weekday-of-month') {
    return getMonthlyLastWeekdayRecurrenceDates({
      startDate: date,
      amount: noOfEvents,
    });
  }

  return [];
}
